import { render, staticRenderFns } from "./profit_loss.vue?vue&type=template&id=3918deb7&scoped=true&"
import script from "./profit_loss.vue?vue&type=script&lang=js&"
export * from "./profit_loss.vue?vue&type=script&lang=js&"
import style0 from "./profit_loss.vue?vue&type=style&index=0&id=3918deb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3918deb7",
  null
  
)

export default component.exports